import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'

import { OTEL_ENABLED } from './constants/otel'
import { GIT_SHA } from './constants/version'
import {
  requestSanitizer,
  responseSanitizer,
} from './utils/logrocketSanitizers'

export const initLogRocket = () => {
  // Gate on the same per-env observability flag OTel uses (successor to the old
  // APM_ENABLED gate) so session replay stays off in local dev.
  if (!OTEL_ENABLED) return
  LogRocket?.init('urnv5v/flowhub', {
    release: GIT_SHA,
    network: { requestSanitizer, responseSanitizer },
  })
  setupLogRocketReact(LogRocket)
}
